import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, TextField, Typography } from "@mui/material";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { FormActions } from "../utils/FormActions";
import { PlayerMetadataFields } from "./PlayerMetadataFields";
/**
 * Shared form for creating and editing an offline (guest) player. Create and
 * update are the same fields with different defaults, submit handler, and
 * labels, so both flows render this.
 */
export const OfflinePlayerForm = ({ title, submitLabel, defaultValues, showSquadNumber = false, isError, errorMessage, footer, onSubmit, onCancel, }) => {
    const { control, handleSubmit, formState: { errors }, } = useForm({ defaultValues });
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: isError, message: errorMessage }), _jsx(Typography, { variant: "h6", children: _jsx("strong", { children: title }) }), _jsxs(Box, { component: "form", role: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, sx: { mt: 1 }, children: [_jsx(Typography, { variant: "h6", children: "Personal Information" }), _jsx(Divider, { style: { margin: "15px 0" } }), _jsx(Controller, { name: "externalUser.firstName", control: control, rules: { required: "First Name is required" }, render: ({ field }) => (_jsx(TextField, { ...field, margin: "normal", fullWidth: true, label: "First Name", required: true, error: !!errors.externalUser?.firstName, helperText: errors.externalUser?.firstName?.message, autoFocus: true })) }), _jsx(Controller, { name: "externalUser.lastName", control: control, rules: { required: "Last Name is required" }, render: ({ field }) => (_jsx(TextField, { ...field, margin: "normal", fullWidth: true, label: "Last Name", required: true, error: !!errors.externalUser?.lastName, helperText: errors.externalUser?.lastName?.message })) }), showSquadNumber && (_jsx(Controller, { name: "squadNumber", control: control, rules: {
                            min: { value: 1, message: "Must be between 1 and 99" },
                            max: { value: 99, message: "Must be between 1 and 99" },
                        }, render: ({ field }) => (_jsx(TextField, { ...field, value: field.value ?? "", onChange: (e) => {
                                const val = e.target.value;
                                field.onChange(val === "" ? null : Number(val));
                            }, margin: "normal", fullWidth: true, label: "Squad Number", type: "number", error: !!errors.squadNumber, helperText: errors.squadNumber?.message ?? "Optional (1-99)", inputProps: { min: 1, max: 99 } })) })), _jsx(Typography, { variant: "h6", sx: { mt: 3 }, children: "Player Details" }), _jsx(PlayerMetadataFields, { control: control, namePrefix: "player." }), _jsx(FormActions, { submitLabel: submitLabel, onCancel: onCancel }), footer] })] }));
};
// Required fields start blank ("") so the user must consciously pick them.
export const DEFAULT_PLAYER_METADATA = {
    nationality: "",
    foot: "",
    positionOne: "",
    positionTwo: "",
    bio: "",
    heading: 50,
    passing: 50,
    positioning: 50,
    defending: 50,
    finishing: 50,
    dribbling: 50,
    shooting: 50,
    tackling: 50,
    crossing: 50,
    leadership: 50,
    communication: 50,
    speed: 50,
    fitness: 50,
    keeping: 50,
};
